import React, {Component} from 'react'
import {observer} from 'mobx-react'

import Checkbox from 'lib/control/Checkbox'
import SpanButton, {Colors} from 'lib/control/SpanButton'
import SpanLink from 'lib/control/SpanLink'

import styles from './ParamsByFeaturesBuilder.less'

@observer export default class ParamsByFeaturesBuilder extends Component {
    render() {
        /** @type {ProfileSettingsContext} */
        const context = this.props.context

        return (
            <div>
                <h2>
                    Характеристики товаров
                </h2>

                <div className={styles['select-mass-control']}>
                    <SpanLink
                        onClick={this.checkAll}
                        pseudo
                    >
                        Выбрать все
                    </SpanLink>
                    <span> / </span>
                    <SpanLink
                        onClick={this.uncheckAll}
                        pseudo
                    >
                        Снять отметку
                    </SpanLink>
                </div>

                <div className={styles['features-block']}>
                    {
                        context.features.map(feature => (
                            <FeatureCheckbox
                                key={feature.code}
                                feature={feature}
                                context={context}
                            />
                        ))
                    }
                </div>

                <div className={styles['control-buttons-block']}>
                    <SpanButton
                        onClick={this.onApply}
                        color={Colors.GREEN}
                    >
                        Добавить
                    </SpanButton> или <SpanLink onClick={this.onCancel}>закрыть</SpanLink>
                </div>
            </div>
        )
    }

    checkAll = () => {
        /** @type {ProfileSettingsContext} */
        const context = this.props.context

        context.toggleAllParamsByFeaturesBuilderFeatures(true)
    }

    checkHalf = () => {
        /** @type {ProfileSettingsContext} */
        const context = this.props.context

        context.toggleAllParamsByFeaturesBuilderFeatures(true)
    }

    uncheckAll = () => {
        /** @type {ProfileSettingsContext} */
        const context = this.props.context

        context.toggleAllParamsByFeaturesBuilderFeatures(false)
    }

    onApply = () => {
        /** @type {ProfileSettingsContext} */
        const context = this.props.context
        const {addCustomParam} = this.props

        context.addNewParamsByFeaturesBuilder(addCustomParam)
    }

    onCancel = () => {
        /** @type {ProfileSettingsContext} */
        const context = this.props.context

        context.closeParamsByFeaturesBuilder()
    }
}

@observer
class FeatureCheckbox extends Component {
    render() {
        /** @type {ProfileSettingsContext} */
        const context = this.props.context
        const feature = this.props.feature

        return (
            <Checkbox
                checked={context.isParamsByFeaturesBuilderFeatureSelected(feature.code)}
                onChange={this.onCheck}
            >
                {feature.name} <span className={styles['hint']}>({feature.code})</span>
            </Checkbox>
        )
    }

    onCheck = (event) => {
        /** @type {ProfileSettingsContext} */
        const context = this.props.context
        const feature = this.props.feature

        context.toggleParamsByFeaturesBuilderFeature(feature.code, event.target.checked)
    }
}